import { render, staticRenderFns } from "./InstructionBtns.vue?vue&type=template&id=038b11be&scoped=true&"
import script from "./InstructionBtns.vue?vue&type=script&lang=js&"
export * from "./InstructionBtns.vue?vue&type=script&lang=js&"
import style0 from "./InstructionBtns.vue?vue&type=style&index=0&id=038b11be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b11be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038b11be')) {
      api.createRecord('038b11be', component.options)
    } else {
      api.reload('038b11be', component.options)
    }
    module.hot.accept("./InstructionBtns.vue?vue&type=template&id=038b11be&scoped=true&", function () {
      api.rerender('038b11be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/InstructionBtns.vue"
export default component.exports